<script setup lang="ts">
import { sportsOutboxService } from "@/outbox/api/services";
import {
  useDeleteOutboxMessagesMutation,
  useOutboxMessagesQuery,
  useResetOutboxMessagesMutation,
} from "@/outbox/api/sportsQueries";
import OutboxServicePage from "@/outbox/components/OutboxServicePage.vue";

definePage({
  meta: {
    auth: ["Developer.Access"],
  },
});
</script>

<template>
  <OutboxServicePage
    :service="sportsOutboxService"
    :collection-query-fn="useOutboxMessagesQuery"
    :use-delete-messages-mutation="useDeleteOutboxMessagesMutation"
    :use-reset-messages-mutation="useResetOutboxMessagesMutation"
  />
</template>
